import { render, staticRenderFns } from "./WeekSelector.vue?vue&type=template&id=314ae2fc"
import script from "./WeekSelector.vue?vue&type=script&lang=ts"
export * from "./WeekSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports